export type VymirTheme = 'light' | 'dark';

// Semantic tokens accept hex values directly.
// shadcn-style tokens (--background, --foreground, --primary, etc.) require
// HSL channel values without the hsl() wrapper because Vymir uses hsl(var(--x)).

const LIGHT_TOKENS: Record<string, string> = {
  // Semantic surface tokens (hex)
  '--accent-primary': '#7c3aed',
  '--accent-primary-hover': '#6d28d9',
  '--accent-on-accent': '#ffffff',
  '--surface-page': '#ffffff',
  '--surface-panel': '#f9fafb',
  '--surface-price-bar': '#f3f4f6',
  '--surface-sunken': '#e5e7eb',
  '--surface-card': '#ffffff',
  '--foreground-primary': '#111827',
  '--foreground-secondary': '#374151',
  '--foreground-tertiary': '#6b7280',
  '--border-default': '#e5e7eb',
  '--border-subtle': '#f3f4f6',
  '--font-body': "'Open Sans', sans-serif",
  '--font-heading': "'Open Sans', sans-serif",
  // shadcn-style tokens — HSL channel values (no hsl() wrapper)
  '--primary': '262 83% 58%',
  '--primary-foreground': '0 0% 100%',
  '--background': '0 0% 100%',
  '--foreground': '222 39% 11%',
  '--muted': '220 14% 96%',
  '--muted-foreground': '220 9% 46%',
  '--border': '220 13% 91%',
  '--radius': '0.5rem'
};

const DARK_TOKENS: Record<string, string> = {
  // Semantic surface tokens (hex)
  '--accent-primary': '#8b5cf6',
  '--accent-primary-hover': '#a78bfa',
  '--accent-on-accent': '#ffffff',
  '--surface-page': '#111827',
  '--surface-panel': '#18212f',
  '--surface-price-bar': '#1f2937',
  '--surface-sunken': '#1f2937',
  '--surface-card': '#1f2937',
  '--foreground-primary': '#f9fafb',
  '--foreground-secondary': '#d1d5db',
  '--foreground-tertiary': '#9ca3af',
  '--border-default': '#374151',
  '--border-subtle': '#2d3748',
  '--font-body': "'Open Sans', sans-serif",
  '--font-heading': "'Open Sans', sans-serif",
  // shadcn-style tokens — HSL channel values (no hsl() wrapper)
  '--primary': '263 90% 66%',
  '--primary-foreground': '0 0% 100%',
  '--background': '222 39% 11%',
  '--foreground': '210 17% 98%',
  '--muted': '215 28% 17%',
  '--muted-foreground': '218 11% 65%',
  '--border': '220 19% 27%',
  '--radius': '0.5rem'
};

export function buildVymirTokens(theme: VymirTheme): Record<string, string> {
  return theme === 'dark' ? DARK_TOKENS : LIGHT_TOKENS;
}
